<template>
  <slot :errors="errors" :validate="validateSlot" />
</template>

<script lang="ts">
import { defineComponent, computed, watch } from 'vue';
import { useField } from 'vee-validate';

export default defineComponent({
  name: 'ValidationProvider',
  props: {
    name: { type: String, default: '' },
    vid: { type: String, default: '' },
    rules: { type: [String, Object], default: '' },
    value: { type: null as any, default: undefined }
  },
  setup(props) {
    const fieldName = computed(() => props.vid || props.name || 'field');
    const ruleRef = computed(() => props.rules as any);

    const { errors, validate, setValue, value } = useField(fieldName, ruleRef, {
      validateOnValueUpdate: false
    });

    watch(
      () => props.value,
      val => {
        if (val !== value.value) setValue(val as any);
      },
      { immediate: true }
    );

    const validateSlot = async (payload?: any) => {
      const nextVal = payload?.target?.value !== undefined ? payload.target.value : payload;
      if (nextVal !== undefined && nextVal !== value.value) setValue(nextVal);
      const res = await validate();
      return { valid: res.valid, errors: errors.value };
    };

    return { errors, validateSlot };
  }
});
</script>
